var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBistro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 80",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 34,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 27,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,19v-2h-4v2c0,1.103,0.897,2,2,2S25,20.103,25,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.533,51.027c0.787-1.387,2.388-2.208,3.995-1.991c0.78-1.384,2.383-2.224,4-2C44.225,45.802,45.543,45,47,45   s2.775,0.802,3.472,2.036c1.616-0.224,3.219,0.616,4,2c1.339-0.18,2.665,0.365,3.528,1.351V22.858c-0.79-0.205-1.479-0.643-2-1.24   C55.266,22.458,54.201,23,53,23s-2.266-0.542-3-1.382C49.266,22.458,48.201,23,47,23s-2.266-0.542-3-1.382   C43.266,22.458,42.201,23,41,23s-2.266-0.542-3-1.382C37.266,22.458,36.201,23,35,23s-2.266-0.542-3-1.382   C31.266,22.458,30.201,23,29,23s-2.266-0.542-3-1.382C25.266,22.458,24.201,23,23,23s-2.266-0.542-3-1.382   C19.266,22.458,18.201,23,17,23s-2.266-0.542-3-1.382C13.266,22.458,12.201,23,11,23s-2.266-0.542-3-1.382   c-0.521,0.597-1.21,1.035-2,1.24V35h2V25h21v36h2v-4h1.556C32.212,56.409,32,55.732,32,55C32,52.952,33.547,51.259,35.533,51.027z    M38,25h16v16H38V25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,19v-2h-4v2c0,1.103,0.897,2,2,2S19,20.103,19,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19v-2H9v2c0,1.103,0.897,2,2,2S13,20.103,13,19z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 49,
    width: 6,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 55,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,29h3v2h-3v4h7.92l1.167,14H15v12h12V31H15v-2h12v-2H10V29z M23,44h2v2h-2V44z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 27,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 34,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.08,37H3.92L3.087,47h13.826L16.08,37z M14,45H6v-2h8V45z M14,41H6v-2h8V41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.888,53.016l-0.76,0.05l-0.25-0.719c-0.363-1.044-1.554-1.628-2.62-1.2l-1.044,0.42l-0.294-1.086   c-0.303-1.116-1.547-1.781-2.662-1.334l-1.044,0.42l-0.294-1.086C48.684,47.609,47.894,47,47,47s-1.684,0.609-1.92,1.481   l-0.294,1.086l-1.044-0.42c-1.115-0.447-2.359,0.218-2.662,1.334l-0.294,1.086l-1.044-0.42c-1.066-0.428-2.257,0.156-2.62,1.2   l-0.25,0.719L35.965,53C34.897,53,34,53.897,34,55s0.897,2,2,2h22c1.103,0,2-0.897,2-2s-0.897-2-2-2L57.888,53.016z M41,55h-2v-2h2   V55z M52,54h-2v-2h2V54z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 59,
    width: 28,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61,11 61,9 3,9 3,11 53,11 53,13 3,13 3,15 61,15 61,13 55,13 55,11  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,19c0,1.103,0.897,2,2,2s2-0.897,2-2v-2h-4V19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,19v-2h-4v2c0,1.103,0.897,2,2,2S31,20.103,31,19z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.382,3 7.618,3 5.618,7 58.382,7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,21c1.103,0,2-0.897,2-2v-2H3v2C3,20.103,3.897,21,5,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,19v-2h-4v2c0,1.103,0.897,2,2,2S43,20.103,43,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,19v-2h-4v2c0,1.103,0.897,2,2,2S37,20.103,37,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,19v-2h-4v2c0,1.103,0.897,2,2,2S55,20.103,55,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,19v-2h-4v2c0,1.103,0.897,2,2,2S49,20.103,49,19z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBistro);
export default __webpack_public_path__ + "static/media/bistro.4d6edd001fd3469ae640d5d961806693.svg";
export { ForwardRef as ReactComponent };